import axios from 'axios'
import Vue from 'vue'

// Data Store
const dataStore = {
  state: {
    width: window.innerWidth,
    loading: false,
    menuOpen: false,
    filePickerPath: '',
    filePickerIndex: 0,
    filePickerSlug: '',
    filePickerType: 'products',
    filesList: null,
    submenu: '',
    spinner: {editPlan: '', deletePlan: ''},
    view: 'loginView',
    pagesView: 'home',
    invoicesView: 'list',
    subscriptionsView: 'list',
    cmsView: false,
    activeSite: null,
    fakeClient: false,
    darkMode: false,
    pageNav: 'home',
    modals: {
      profile: false,
      iconModal: false,
      cartAdded: false,
      wizard: false,
      filePicker: false
    },
    selectedIcon: null,
    selectedOrder: 0,
    selectedCategory: {
      title: null
    },
    mainURL: 'https://levelsevenstudio.com/api/api.php',
    currentDomainSearch: {},
    tinymceInit: {
      plugins: 'code, autoresize, link, lists',
      autoresize_bottom_margin: 0,
      statusbar: false,
      max_height: 300,
      menubar: false,
      toolbar: 'undo redo | bold italic underline forecolor | formatselect | alignleft aligncenter alignright |  numlist bullist | link | removeformat | code',
      forced_root_block : '',
      relative_urls: false
    },
    user: {
      email: '',
      displayName: '',
      businessName: '',
      companyLogo: '',
      phone: '',
      address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: ''
      },
      gravatarEmail: '',
      gravatar: '',
      emailSent: null,
      status: '',
      custid: '',
      isAdmin: false,
      domains: {list: [], total: 0, page: 1},
      invoices: {list: [], total: 0, unpaid: 0, overdue: 0, activeInvoice: null},
      subs: {list: [], total: 0},
      sites: {list: [], total: 0},
      emails: {total: 0},
      messages: {total: 0},
      stripeid: '',
      stripeData: {
        sources: {
          data: []
        }
      }
    },
    authUser: false,
    error: {
      code: '',
      message: ''
    },
    authHeader: {
      Authorization: ''
    },
    admin: {
      global: {
        income: {
          yesterday: 0,
          month: 0,
          year: 0,
          list: []
        },
        expenses: {
          yesterday: 0,
          month: 0,
          year: 0,
          list: []
        },
        invoices: {
          list: [],
          total: 0,
          paid: 0,
          unpaid: 0,
          overdue: 0
        },
        tickets: {
          unread: 0,
          total: 0,
          list: []
        },
        clients: {
          active: 0,
          suspended: 0,
          cancelled: 0,
          total: 0,
          list: [],
          searchClients: [],
          searchClientTerm: ''
        },
        products: [],
        plans: {
          data: []
        },
        subs: {
          data: []
        }
      },
      client: {
        email: '',
        data: null,
        invoices: {
          list: [],
          total: 0,
          paid: 0,
          unpaid: 0,
          overdue: 0
        },
        domains: {
          list: [],
          total: 0,
          page: 1
        }
      }
    },
    cart: {
      items: [],
      total: 0
    },
    savedCart: {
      items: [],
      total: 0
    },
    order: null,
    productData: null,
    productRatings: [],
    domainPlan: null,
    siteData: null,
    siteAnalytics: {
      visitors: {},
      uniqVisitors: {},
      bounceRate: {}
    }
  },
  registerUser(data) {
    return new Promise(resolve => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=signup', {
        email: data.email,
        password: data.password,
        name: data.displayName,
        phone: data.phone,
        company: data.businessName,
        address1: data.address.address1,
        address2: data.address.address2,
        city: data.address.city,
        state: data.address.state,
        zip: data.address.zip,
        clubcmd: false
      }).then((response) => {
        this.state.loading = false
        if (response.data.code !== 'success') {
          resolve(response)
        } else {
          this.state.user.email = data.email
          this.state.user.displayName = data.displayName
          this.state.user.phone = data.phone
          this.state.user.businessName = data.company
          this.state.user.address = {
            address1: data.address.address1,
            city: data.address.city,
            state: data.address.state,
            zip: data.address.zip
          }
          this.state.user.status = 'new'
          this.state.user.custid = response.data.custid
          this.state.authUser = true

          this.makeHeader(data.email, data.password)
          resolve('success')
        }
      }).catch(error => {
        this.state.error = error.data
      })
    })
  },
  makeHeader(email, pw) {
    return new Promise(resolve => {
      this.state.authHeader = {
        Authorization: 'Basic ' + btoa(email + ':' + pw)
      }
      if (typeof (Storage) !== 'undefined') {
        localStorage.setItem('l7_userauth', JSON.stringify(this.state.authHeader))
      } else {
        console.log('No localstorage...?')
      }
      resolve('done')
    })
  },
  loginUser() {
    return new Promise(resolve => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=login', {}, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'error') {
          this.state.error.message = response.data.message
          this.state.loading = false
          resolve(this.state.error)
        } else if (response.data.code === 'success') {
          if (response.data.data) {
            const user = response.data.data
            this.state.user.email = user.email
            this.state.user.displayName = user.name
            this.state.user.phone = user.phone
            this.state.user.businessName = user.company
            this.state.user.companyLogo = user.companyLogo
            this.state.user.address = { address1: user.address1, city: user.city, state: user.state, zip: user.zipcode }
            this.state.user.user_group = user.user_group
            this.state.user.status = user.status

            this.state.user.custid = user.custid

            this.state.user.stripeid = user.stripeid
            this.state.user.stripeData = user.stripeData

            this.state.user.invoices = { 'list': user.invoices.data, 'total': user.invoices.data.length }
            this.state.user.invoices.unpaid = (this.state.user.invoices.list.filter(item => item.status === 'unpaid')).length
            this.state.user.invoices.overdue = (this.state.user.invoices.list.filter(item => item.status === 'overdue')).length

            this.state.user.subs = { 'list': user.subs.data, 'total': user.subs.data.length }
            for (let sub of this.state.user.subs.list) {
              sub.total = 0
              for (let item of sub.items.data) {
                sub.total += item.plan.amount
              }
            }

            if (user.gravatar !== '') {
              this.state.user.gravatar = user.gravatar
            } else {
              this.state.user.gravatar = require('./assets/avatar.png')
            }

            this.state.user.messages = { total: 0 }
          }

          // Resellerclub Data checks
          this.getCustomerDomains(1)
          this.getCustomerEmails(1)

          // Admin
          if (this.state.user.user_group === 'super') {
            this.getAdminGlobalData().then((result) => {
              this.state.authUser = true
              this.state.user.isAdmin = true
              this.state.view = 'userView'
              this.state.loading = false
            })
          } else {
            this.state.authUser = true
            if (this.state.user.status === 'new') {
              this.state.view = 'verifyEmailView'
            } else if (this.state.user.status === 'active') {
              this.state.view = 'userView'
            } else {
              // ERROR? status is something other than active or new?
            }
            this.state.loading = false
          }
          resolve('success')
        } else {
          this.state.error = response.data
          this.state.loading = false
          resolve(this.state.error)
        }
      }).catch(error => {
        this.state.loading = false
        this.state.error = error.data
        resolve(error)
      })
    })
  },
  getCustomerDomains(page) {
    axios.get(this.state.mainURL + '?customer=domainsList&customer-id=' + this.state.user.custid + '&page-no=' + page, {headers: this.state.authHeader}).then((response) => {
      if (response.data.data) {
        let myDomains = []
        for (let item of Object.keys(response.data.data)) {
          if (!isNaN(item)) {
            myDomains.push(response.data.data[item])
          }
        }
        this.state.user.domains = {
          'total': response.data.data.recsindb,
          'list': myDomains
        }
      } else {
        console.log('error getting customer domains')
      }
    }).catch(error => {
      this.state.loading = false
      this.state.error = error.data
    })
  },
  getCustomerEmails(page) {
    let ordersRequest = 'eelite/us/search.json'
    let customerid = this.state.user.custid
    axios.get(this.state.mainURL + '?customer=searchOrders&customer-id=' + customerid + '&page-no=' + page + '&request=' + ordersRequest, {headers: this.state.authHeader}).then((response) => {
      if (response.data.code === 'success') {
        let data = JSON.parse(response.data.data)
        let keys = Object.keys(data)
        let myEmailOrders = []
        for (let key of keys) {
          if (!isNaN(key)) {
            myEmailOrders.push(data[key])
          }
        }
        for (let order of myEmailOrders) {
          let orderid = order['orders.orderid']
          let detailsRequest = 'eelite/us/details.json'
          axios.get(this.state.mainURL + '?customer=orderDetails&order-id=' + orderid + '&request=' + detailsRequest, {headers: this.state.authHeader}).then((response2) => {
            let emailOrder = JSON.parse(response2.data.data)
            let emailDomain = emailOrder.domainname
            this.state.user.emails[emailDomain] = emailOrder
            this.state.user.emails.total = this.state.user.emails.total + emailOrder.emailaccounts
          }).catch(error => {
            this.state.loading = false
            this.state.error = error.data
          })
        }
      } else {
        console.log('error getting customer emails')
      }
    }).catch(error => {
      this.state.loading = false
      this.state.error = error.data
    })
  },
  getCustomerSubs() {
    axios.get(this.state.mainURL + '?customer=subsList', {headers: this.state.authHeader}).then((response) => {
      this.state.user.subs = { 'list': response.data.data.data, 'total': response.data.data.data.length }
      for (let sub of this.state.user.subs.list) {
        sub.total = 0
        for (let item of sub.items.data) {
          sub.total += item.plan.amount
        }
      }
    }).catch((error) => {
      this.state.error = error
    })
  },
  getCustomerInvoices() {
    axios.get(this.state.mainURL + '?customer=invoicesList', {headers: this.state.authHeader}).then((response) => {
      this.state.user.invoices = { 'list': response.data.data.data, 'total': response.data.data.data.length }
      for (let invoice of this.state.user.invoices.list) {
        invoice.total = 0
        if (invoice.items) {
          for (let item of invoice.items.data) {
            invoice.total += item.plan.amount
          }
        }
      }
    }).catch((error) => {
      this.state.error = error
    })
  },
  getFiles() {
    axios.post(this.state.mainURL + '?files=list', {domain: this.state.activeSite.domain}, {headers: this.state.authHeader}).then((response) => {
      if (response.data.data) {
        this.state.filesList = response.data.data.sort()
        this.state.modals.filePicker = true
      }
    }).catch(error => {
      this.state.loading = false
      this.state.error = error.data
    })
  },
  refreshCustomerData() {
    this.getCustomerSubs()
    this.getCustomerInvoices()
    this.getCustomerDomains(1)
  },
  signOut() {
    this.state.user = {
      email: '',
      displayName: '',
      businessName: '',
      phone: '',
      address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: ''
      },
      gravatarEmail: '',
      gravatar: '',
      emailSent: null,
      status: '',
      custid: '',
      isAdmin: false,
      domains: {
        list: [],
        total: 0,
        page: 1
      },
      invoices: {
        total: 0,
        unpaid: 0,
        overdue: 0,
        list: []
      },
      subs: {
        total: 0,
        list: []
      },
      messages: {
        total: 0
      },
      stripeid: '',
      stripeData: {
        sources: {
          data: []
        }
      },
      user_group: 'user'
    }
    this.state.cart = {
      items: [],
      total: 0
    }
    this.state.authUser = false
    this.state.view = 'loginView'
    localStorage.removeItem('l7_userauth')
    localStorage.removeItem('l7_cart')
  },
  updateUser() {
    let postData = {
      email: this.state.user.email,
      gravatar: this.state.user.gravatar,
      name: this.state.user.displayName,
      phone: this.state.user.phone,
      company: this.state.user.businessName,
      address1: this.state.user.address.address1,
      address2: this.state.user.address.address2,
      city: this.state.user.address.city,
      state: this.state.user.address.state,
      zip: this.state.user.address.zip
    }
    axios.post(this.state.mainURL + '?customer=update', postData, {headers: this.state.authHeader}).catch(error => {
      this.state.error = error.data
    })
  },
  getConfig() {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.get(this.state.mainURL + '?admin=getConfig', {headers: this.state.authHeader}).then((response) => {
        this.state.loading = false
        if (response.data.code === 'success') {
          this.state.config = response.data.data
          resolve('success')
        } else {
          resolve('error')
        }
      }).catch((error) => {
        this.state.loading = false
        this.state.error = error
        resolve('error')
      })
    })
  },
  saveConfig(category, json) {
    this.state.loading = true
    let postData = {
      category: category,
      json: json
    }
    axios.post(this.state.mainURL + '?admin=saveConfig', postData, {headers: this.state.authHeader}).catch(error => {
      this.state.loading = false
      this.state.error = error.data
    }).finally(() => {
      this.state.loading = false
    })
  },
  addCard(card) {
    this.state.user.stripeData.sources.data.push(card)
  },
  removeCard(id) {
    let postData = {
      stripeid: this.state.user.stripeid,
      source: id
    }
    axios.post(this.state.mainURL + '?customer=removeStripeCard', postData, {headers: this.state.authHeader}).then((response) => {
      if (response.data.data.deleted === true) {
        const i = this.state.user.stripeData.sources.data.findIndex(item => item.id === response.data.data.id)
        this.state.user.stripeData.sources.data.splice(i, 1)
        this.state.user.stripeData.default_source = ''
      }
    }).catch(error => {
      this.state.error = error.data
    }).finally(() => {
      this.updateUser()
    })
  },
  updateStripeDefaultSource(id) {
    this.state.user.stripeData.default_source = id
    let postData = {
      stripeid: this.state.user.stripeid,
      default_source: id
    }
    axios.post(this.state.mainURL + '?customer=updateStripeDefaultSource', postData, {headers: this.state.authHeader}).catch((error) => {
      this.state.error = error.data
    })
  },
  getAllProducts() {
    return new Promise((resolve) => {
      axios.get(this.state.mainURL + '?customer=getAllProducts', {headers: this.state.authHeader}).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        this.state.error = error.data
      })
    })
  },
  toggleClientFake() {
    this.state.fakeClient = !this.state.fakeClient
  },
  toggleMenu(menu) {
    this.state.submenu = menu
    var mySidebar = document.getElementById('mySidebar')
    if (mySidebar.style.display === 'block') {
      this.state.menuOpen = false
      mySidebar.style.display = 'none'
    } else {
      this.state.menuOpen = true
      mySidebar.style.display = 'block'
    }
  },
  getAdminGlobalData() {
    return new Promise(resolve => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?admin=global', {}, {headers: this.state.authHeader}).then((response) => {
        this.state.admin.global.clients = {
          list: response.data.clients,
          searchClients: response.data.clients,
          total: response.data.clients.length,
          active: (response.data.clients.filter(item => item.status === 'active')).length,
          cancelled: (response.data.clients.filter(item => item.status === 'cancelled')).length,
          suspended: (response.data.clients.filter(item => item.status === 'suspended')).length
        }
        this.state.admin.global.invoices = {
          list: response.data.invoices,
          total: response.data.invoices.length,
          paid: (response.data.invoices.filter(item => item.status === 'paid')).length,
          unpaid: (response.data.invoices.filter(item => item.status === 'open')).length,
          overdue: (response.data.invoices.filter(item => item.status === 'overdue')).length
        }

        this.state.admin.global.products = response.data.products
        this.state.admin.global.plans = response.data.plans
        this.state.admin.global.subs = response.data.subs
        for (let sub of this.state.admin.global.subs.data) {
          sub.total = 0
          for (let item of sub.items.data) {
            sub.total += item.plan.amount
          }
        }

        this.state.loading = false
        resolve('success')
      })
    })
  },
  saveInvoice(invoice) {
    return new Promise(resolve => {
      let postData = {
        stripeid: invoice.client.stripeid,
        items: JSON.stringify(invoice.items),
        issue_date: invoice.issue_date,
        due_date: invoice.due_date,
        status: invoice.status
      }
      axios.post(this.state.mainURL + '?admin=addInvoice', postData, {headers: this.state.authHeader}).then(response => {
        if (response.data.code === 'success') {
          resolve(response.data.data)
        } else {
          this.state.error = response.data
          resolve('error')
        }
      }).catch(error => {
        this.state.error = error.data
      })
    })
  },
  saveClient(client) {
    return new Promise(resolve => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?admin=addClient', client, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code !== 'success') {
          this.state.error.message = response.data.message
        } else {
          dataStore.getAdminGlobalData()
          resolve('success')
        }
      }).catch((error) => {
        this.state.error = error.data
        resolve('error')
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  updateClient(client) {
    return new Promise(resolve => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?admin=updateClient', client, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          resolve('success')
        } else {
          this.state.error.message = response.data.message
        }
      }).catch((error) => {
        this.state.error = error.data
        resolve('error')
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  removeClient(email) {
    this.state.loading = true
    axios.post(this.state.mainURL + '?admin=removeClient', {'email': email}, {headers: this.state.authHeader}).then((response) => {
      if (response.data.code === 'success') {
        dataStore.getAdminGlobalData()
      } else {
        this.state.error.message = response.data.message
      }
    }).catch((error) => {
      this.state.error = error.data
    }).finally(() => {
      this.state.loading = false
    })
  },
  saveProduct(product) {
    return new Promise(resolve => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?admin=addStripeProduct', product, {headers: this.state.authHeader}).then(response => {
        if (response.data.code === 'success') {
          resolve(response.data.data)
        } else {
          this.state.error.message = response.data.message
        }
      }).catch(error => {
        this.state.error = error.data
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  savePlan(plan) {
    return new Promise(resolve => {
      plan.amount = plan.amount * 100
      axios.post(this.state.mainURL + '?admin=addStripePlan', plan, {headers: this.state.authHeader}).then(response => {
        if (response.data.code === 'success') {
          resolve('success')
        } else {
          this.state.error.code = response.data.code
          this.state.error.message = response.data.message
          resolve('error')
        }
      }).catch(error => {
        this.state.error = error.data
        resolve('error')
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  saveSubscription(sub, isAdmin) {
    return new Promise(resolve => {
      this.state.loading = true
      const url = isAdmin ? '?admin=subscribeStripeCustomer' : '?customer=subscribe'
      axios.post(this.state.mainURL + url, sub, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          resolve(response)
        } else {
          this.state.error.message = response.data.message
        }
      }).catch((error) => {
        this.state.error = error.data
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  cancelSubscription(sub, isAdmin) {
    return new Promise(resolve => {
      this.state.loading = true
      const url = isAdmin ? '?admin=cancelStripeCustomerSubscription' : '?customer=cancelSubscription'
      axios.post(this.state.mainURL + url, sub, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          resolve(response)
        } else {
          this.state.error.message = response.data.message
        }
      }).catch((error) => {
        this.state.error = error.data
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  deletePlan(planid) {
    this.state.loading = true
    this.state.spinner.deletePlan = planid
    axios.post(this.state.mainURL + '?admin=deleteStripePlan', {'planid': planid}, {headers: this.state.authHeader}).then((response) => {
      if (response.data.code === 'success') {
        dataStore.getAdminGlobalData().then(() => {
          this.state.spinner.deletePlan = ''
        })
      } else {
        this.state.error.message = response.data.message
      }
    }).catch((error) => {
      this.state.error = error.data
    }).finally(() => {
      this.state.loading = false
    })
  },
  deleteProduct(productid) {
    this.state.loading = true
    axios.post(this.state.mainURL + '?admin=deleteStripeProduct', {'productid': productid}, {headers: this.state.authHeader}).then((response) => {
      if (response.data.code === 'success') {
        dataStore.getAdminGlobalData()
      } else {
        this.state.error.message = response.data.message
      }
    }).catch((error) => {
      this.state.error = error.data
    }).finally(() => {
      this.state.loading = false
    })
  },
  getClientInvoices(client) {
    this.state.loading = true
    axios.post(this.state.mainURL + '?admin=getClientInvoices', {stripeid: client.stripeid}, {headers: this.state.authHeader}).then((response) => {
      this.state.admin.client.invoices = {
        list: response.data.data.data,
        total: response.data.data.data.length,
        paid: (response.data.data.data.filter(item => item.status === 'paid')).length,
        unpaid: (response.data.data.data.filter(item => item.status === 'open')).length,
        overdue: (response.data.data.data.filter(item => item.status === 'overdue')).length
      }
    }).catch((error) => {
      this.state.error = error.data
    }).finally(() => {
      this.state.loading = false
    })
  },
  getClientDomains(client, page) {
    this.state.loading = true
    axios.get(this.state.mainURL + '?customer=domainsList&customer-id=' + client.custid + '&page-no=' + page, {headers: this.state.authHeader}).then((response) => {
      if (response.data.data) {
        let clientDomains = []
        for (let item of Object.keys(response.data.data)) {
          if (!isNaN(item)) {
            clientDomains.push(response.data.data[item])
          }
        }
        this.state.admin.client.domains = {
          'total': response.data.data.recsindb,
          'list': clientDomains
        }
      } else {
        console.log('error getting client domains')
      }
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      this.state.loading = false
    })
  },
  getClientEmails(client, page) {
    this.state.loading = true
    axios.get(this.state.mainURL + '?customer=businessEmailList&customer-id=' + client.custid + '&page-no=' + page, {headers: this.state.authHeader}).then((response) => {
      if (response.data.data) {
        let clientEmails = []
        for (let item of Object.keys(response.data.data)) {
          if (!isNaN(item)) {
            clientEmails.push(response.data.data[item])
          }
        }
        this.state.admin.client.emails = {
          'total': response.data.data.recsindb,
          'list': clientEmails
        }
      } else {
        console.log('error getting client emails')
      }
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      this.state.loading = false
    })
  },
  getClientSites() {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.get(this.state.mainURL + '?customer=sitesList&timestamp=' + new Date().getTime(), {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          let sites = response.data.data
          this.state.user.sites = {
            'total': sites.length,
            'list': sites.sort()
          }
          resolve('success')
        } else {
          resolve(response)
        }
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  getSiteData(domain) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=getSiteData&timestamp=' + new Date().getTime(), {domain: domain}, {headers: this.state.authHeader}).then((response) => {
        resolve(response.data.code === 'success' ? response.data.data : response)
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  getProductReviews(domain) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=getProductReviews', {domain: domain}, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          this.state.productRatings = JSON.parse(response.data.data)
          resolve('success')
        } else {
          resolve('error')
        }
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  deleteRating(id) {
    return new Promise((resolve) => {
      let postData = {
        id: id,
        domain: this.state.activeSite.domain
      }
      axios.post(this.state.mainURL + '?customer=deleteRating', postData).then((res) => {
        resolve(res.data.code === 'success' ? 'success' : 'error')
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  updateRating(id, status) {
    return new Promise((resolve) => {
      let postData = {
        id: id,
        domain: this.state.activeSite.domain,
        status: status
      }
      axios.post(this.state.mainURL + '?customer=updateRating', postData).then((res) => {
        if (res.data.code === 'success') {
          resolve('success')
        } else {
          resolve('error')
        }
      })
    })
  },
  getOrders() {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.get(this.state.mainURL + '?customer=sitesList', {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          let sites = response.data.data
          // TODO: change to just updating orders and not whole site data
          this.state.user.sites = {
            'total': sites.length,
            'list': sites
          }
          resolve('success')
        } else {
          resolve(response)
        }
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  getSiteUsers(domain) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.get(this.state.mainURL + '?customer=getSiteUsers&domain=' + domain, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          this.state.activeSite.users = response.data.data
          resolve('success')
        } else {
          resolve(response)
        }
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  getSiteLeads() {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=siteLeads', {domain: this.state.activeSite.domain}, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          this.state.activeSite.leads = response.data.data
          resolve('success')
        } else {
          resolve(response)
        }
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  deleteLead(id) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=deleteLead', {domain: this.state.activeSite.domain, id: id}, {headers: this.state.authHeader}).then((response) => {
        resolve(response.data.code === 'success' ? 'success' : 'error')
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  markRead(id) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=markRead', {domain: this.state.activeSite.domain, id: id}, {headers: this.state.authHeader}).then((response) => {
        if (response.data.code === 'success') {
          let selectedLeadIndex = this.state.activeSite.leads.findIndex((lead) => {
            return lead.id === id
          })
          let selectedLead = this.state.activeSite.leads.find((lead) => {
            return lead.id === id
          })
          selectedLead.status = 'read'
          Vue.set(this.state.activeSite.leads, selectedLeadIndex, selectedLead)
          resolve('success')
        } else {
          resolve(response)
        }
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  sendLeadReply(data) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=sendLeadReply', data, {headers: this.state.authHeader}).then((response) => {
        resolve(response)
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  saveSiteData() {
    return new Promise((resolve) => {
      // New
      let postData = {
        domain: this.state.activeSite.domain,
        json: JSON.stringify(this.state.siteData)
      }
      axios.post(this.state.mainURL + '?customer=saveSiteData&timestamp=' + new Date().getTime(), postData, {headers: this.state.authHeader}).then((res) => {
        resolve(res.data.code === 'success' ? 'success' : 'error')
        // test output site
        // axios.get(this.state.mainURL + '?customer=outputSite&domain=' + postData.domain + '&timestamp=' + new Date().getTime()).then((res) => {
        //   console.log(res)
        // })
      })
    })
  },
  saveSiteProducts() {
    return new Promise((resolve) => {
      let postData = {
        domain: this.state.activeSite.domain,
        json: JSON.stringify(this.state.siteData.content.products)
      }
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=saveSiteProducts', postData, {headers: this.state.authHeader}).then((res) => {
        resolve(res.data.code === 'success' ? 'success' : 'error')
      }).catch((error) => {
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  getChargeDetails(chargeid) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?customer=getChargeDetails', {chargeid: chargeid}, {headers: this.state.authHeader}).then((response) => {
        resolve(response)
      }).catch((error) => {
        this.state.error = error.data
        resolve(error)
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  sendEmail(contact) {
    return new Promise((resolve) => {
      axios.post(this.state.mainURL + '?customer=sendEmail', {contact: contact}).then((response) => {
        resolve('success')
      }).catch((error) => {
        this.state.error = error.data
        resolve('error')
      })
    })
  },
  setProperty(path, value) {
    var schema = this.state
    var pList = path.split('.')
    var len = pList.length
    for (var i = 0; i < len - 1; i++) {
      var elem = pList[i]
      if (!schema[elem]) schema[elem] = {}
      schema = schema[elem]
    }
    schema[pList[len - 1]] = value
  },
  getProperty(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
      return prev ? prev[curr] : null
    }, obj || self)
  },
  uploadImage(files) {
    return new Promise((resolve) => {
      let formData = new FormData()
      formData.append('image', files[0])
      formData.append('domain', this.state.activeSite.domain)
      axios.post(this.state.mainURL + '?customer=uploadImage', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
        resolve(response.data.path)
      })
    })
  },
  uploadDoc(files) {
    return new Promise((resolve) => {
      let formData = new FormData()
      formData.append('image', files[0])
      formData.append('domain', this.state.activeSite.domain)
      axios.post(this.state.mainURL + '?customer=uploadDoc', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
        resolve(response.data.path)
      })
    })
  },
  getAnalytics(method, siteid, period, date) {
    return new Promise((resolve) => {
      this.state.loading = true
      axios.post(this.state.mainURL + '?analytics=' + method, {siteid: siteid, period: period, date: date}).then((response) => {
        if (method === 'getVisitors') {
          this.state.siteAnalytics.visitors = response.data.data
        }
        // if (method === 'getUniqueVisitors') {
        //   this.state.siteAnalytics.uniqVisitors = response.data.data
        // }
        resolve('success')
      }).catch((error) => {
        resolve('error')
        // this.state.error = error.data
      }).finally(() => {
        this.state.loading = false
      })
    })
  },
  initSiteData() {
    this.state.siteData = {
      site_name: '',
      site_title: '',
      site_keywords: '',
      site_description: '',
      site_logo: {
        url: 'img/logo2.png',
        alt: 'Business Logo Header Image'
      },
      site_l7s_analytics_id: '',
      site_google_api_key: '',
      site_google_analytics_key: '',
      site_google_tag: '',
      site_google_recaptcha_key: '',
      site_google_recaptcha_secret_key: '',
      site_shippo_key: '',
      site_clickatell_key: '',
      site_clickatell_from: '',
      site_mailgun_key: '',
      site_stripe_key: '',
      site_stripe_pkey: '',
      site_cookie_popup: false,
      site_pages: [],
      contact: {
        address: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          zip: ''
        },
        phone: '',
        phone2: '',
        email: '',
        notification_email: '',
        email_subject: '',
        hours: '',
        lat: '',
        lng: ''
      },
      social: {
        image: '',
        facebook: '',
        twitter: '',
        instagram: '',
        linkedin: '',
        googleplus: ''
      },
      theme: 'classic',
      header: {
        type: 'classic',
        dark: false,
        topColored: 'none',
        sticky: true,
        stickyMobile: true,
        stickyShrink: true,
        stickyTop: 25,
        logoWidth: 283,
        logoHeight: 60,
        topAbout: true,
        topContact: true,
        topPhone: true,
        topEmail: true,
        topSearch: true,
        topCart: true,
        languageSelect: false
      },
      pageHeader: {
        type: 'modern-medium'
      },
      footer: {
        type: 'classic',
        about: {
          enabled: true,
          text: ''
        },
        color: ''
      },
      nav: {
        type: 'pills',
        square: false,
        left: false
      },
      leads: [],
      colors: {
        primary: {
          main: '#00838f',
          text: '#fafafa',
          border: '#1e88e5',
          hover: '#42a5f5',
          active: '#1976d2',
          activeBorder: '#1976d2'
        },
        secondary: {
          main: '#4caf50',
          text: '#fafafa',
          border: '#43a047',
          hover: '#66bb6a',
          active: '#388e3c',
          activeBorder: '#388e3c'
        },
        tertiary: {
          main: '#f44336',
          text: '#fafafa',
          border: '#e53935',
          hover: '#ef5350',
          active: '#d32f2f',
          activeBorder: '#d32f2f'
        },
        quaternary: {
          main: '#37474f',
          text: '#fafafa',
          border: '#263238',
          hover: '#42a5f5',
          active: '#455a64',
          activeBorder: '#263238'
        },
        dark: {
          main: '#2e3e4e',
          text: '#fafafa',
          border: '#263238',
          hover: '#212121',
          active: '#212121',
          activeBorder: '#212121'
        },
        light: {
          main: '#fefefe',
          text: '#212121',
          border: '#f5f5f5',
          hover: '#f2f2f2',
          active: '#f2f2f2',
          activeBorder: '#f2f2f2'
        }
      },
      pages: {
        home: {
          type: 'classic',
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          sections: {
            slider: {
              enabled: true,
              type: 'classic',
              quoteBG: 'primary',
              slide1: {
                src: '',
                overlay: false,
                line1text: '',
                line2text: '',
                line3text: '',
                button1enabled: false,
                button1text: '',
                button1url: '',
                button2enabled: false,
                button2text: '',
                button2url: '',
                button3enabled: false,
                button3text: '',
                button3url: ''
              },
              slide2: {
                src: '',
                overlay: false,
                line1text: '',
                line2text: '',
                line3text: '',
                button1enabled: false,
                button1text: '',
                button1url: '',
                button2enabled: false,
                button2text: '',
                button2url: '',
                button3enabled: false,
                button3text: '',
                button3url: ''
              },
              slide3: {
                src: '',
                overlay: false,
                line1text: '',
                line2text: '',
                line3text: '',
                button1enabled: false,
                button1text: '',
                button1url: '',
                button2enabled: false,
                button2text: '',
                button2url: '',
                button3enabled: false,
                button3text: '',
                button3url: ''
              }
            },
            cta: {
              enabled: true,
              text: '',
              button1: {
                enabled: true,
                text: '',
                url: ''
              },
              button2: {
                enabled: true,
                text: '',
                url: ''
              }
            },
            features: {
              enabled: true,
              type: 'style1',
              style1: {
                title: 'Our <strong class="font-weight-extra-bold">Features</strong>',
                subtitle: 'and more...',
                items: {
                  feature1: {
                    icon: 'palette',
                    title: '',
                    text: ''
                  },
                  feature2: {
                    icon: 'chart-line',
                    title: '',
                    text: ''
                  },
                  feature3: {
                    icon: 'globe',
                    title: '',
                    text: ''
                  },
                  feature4: {
                    icon: 'envelope',
                    title: '',
                    text: ''
                  },
                  feature5: {
                    icon: 'cloud',
                    title: '',
                    text: ''
                  },
                  feature6: {
                    icon: 'upload',
                    title: '',
                    text: ''
                  },
                  feature7: {
                    icon: 'lock',
                    title: '',
                    text: ''
                  },
                  feature8: {
                    icon: 'file-alt',
                    title: '',
                    text: ''
                  }
                }
              },
              style2: {
                items: {
                  feature1: {
                    src: '',
                    title: '',
                    subtitle: '',
                    text: '',
                    url: ''
                  },
                  feature2: {
                    src: '',
                    title: '',
                    subtitle: '',
                    text: '',
                    url: ''
                  },
                  feature3: {
                    src: '',
                    title: '',
                    subtitle: '',
                    text: '',
                    url: ''
                  }
                }
              },
              style3: {
                title: 'Our <strong class="font-weight-extra-bold">Features</strong>',
                subtitle: 'and more...',
                items: {
                  feature1: {
                    icon: 'palette',
                    title: '',
                    text: ''
                  },
                  feature2: {
                    icon: 'chart-line',
                    title: '',
                    text: ''
                  },
                  feature3: {
                    icon: 'globe',
                    title: '',
                    text: ''
                  },
                  feature4: {
                    icon: 'envelope',
                    title: '',
                    text: ''
                  },
                  feature5: {
                    icon: 'cloud',
                    title: '',
                    text: ''
                  },
                  feature6: {
                    icon: 'upload',
                    title: '',
                    text: ''
                  }
                }
              }
            },
            services: {
              enabled: false,
              type: 'style1',
              divider: false,
              style1: {
                title: '',
                subtitle: '',
                margintop: 0,
                titleDivider: false,
              },
              style2: {
                title: '',
                subtitle: ''
              }
            },
            about: {
              enabled: true,
              type: 'basic',
              basic: {
                title: '',
                text: ''
              },
              dividers: {
                about1: {
                  enabled: true,
                  title: '',
                  subtitle: '',
                  text: ''
                },
                about2: {
                  enabled: true,
                  title: '',
                  subtitle: '',
                  text: ''
                },
                about3: {
                  enabled: true,
                  title: '',
                  subtitle: '',
                  text: ''
                }
              },
              law: {
                title: '',
                text: '',
                title2: '',
                text2: ''
              }
            },
            shop: {
              enabled: false,
              productsType: 'carousel'
            },
            portfolio: {
              enabled: false,
              type: 'grid-1-column-detailed',
              detailType: 'small-slider',
              divider: 'none',
              color: '#212121',
              background: '#f7f7f7'
            },
            news: {
              enabled: false
            },
            newsletter: {
              enabled: false,
              url: ''
            },
            testimonials: {
              enabled: false,
              url: '',
              image: {
                src: '',
              }
            },
            team: {
              enabled: false,
              url: '',
              type: 'law-firm',
              cols: '4'
            },
            custom: {
              enabled: false,
              text: ''
            },
            contact: {
              enabled: false,
              type: 'consultation'
            },
            sidebar: {
              enabled: false,
            }
          }
        },
        services: {
          enabled: true,
          content: '',
          listTitle: '',
          menuText: 'Services',
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          image: {
            alt: '',
            src: ''
          },
          url: 'services',
          originalurl: 'services',
        },
        about: {
          enabled: true,
          type: 'sidebar',
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          image: {
            alt: '',
            src: ''
          },
          content: {
            main: '',
            custom: ''
          },
          partners: true,
          testimonials: false,
          url: 'about-us',
          originalurl: 'about-us'
        },
        news: {
          enabled: true,
          type: 'grid-4-columns',
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          image: {
            alt: '',
            src: ''
          },
          detailtype: 'small-image',
          url: 'news',
          originalurl: 'news'
        },
        shop: {
          enabled: false,
          type: '4-columns',
          detailtype: 'full-width',
          customEnabled: false,
          customText: '',
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          image: {
            alt: '',
            src: ''
          },
          tabs: {
            tab1enabled: '',
            tab1title: '',
            tab1content: '',
            tab2enabled: '',
            tab2title: '',
            tab2content: '',
            tab3enabled: '',
            tab3title: '',
            tab3content: '',
            tab4enabled: '',
            tab4title: '',
            tab4content: '',
          },
          url: 'shop',
          originalurl: 'shop'
        },
        portfolio: {
          enabled: false,
          type: 'construction'
        },
        contact: {
          enabled: true,
          teamEnabled: false,
          type: 'contact-us-recaptcha',
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          image: {
            alt: '',
            src: ''
          },
          content: {
            custom: ''
          },
          url: 'contact-us',
          originalurl: 'contact-us'
        },
        team: {
          enabled: false,
          type: 'dropdown',
          url: 'our-team',
          originalurl: 'our-team'
        },
        repairs: {
          enabled: false,
          seo: {
            title: '',
            description: '',
            keywords: ''
          },
          image: {
            alt: '',
            src: ''
          },
          lead: '',
          button1text: '',
          button2text: '',
          button3text: '',
          content: '',
          statusContent: '',
          url: 'repairs',
          originalurl: 'repairs'
        },
        sitemap: {
          content: ''
        },
        custom: {
          enabled: false,
          items: []
        }
      },
      content: {
        services: {
          enabled: false,
          type: 'wide-basic',
          detailtype: 'basic',
          items: []
        },
        products: {
          enabled: false,
          cartEnabled: true,
          categories: [],
          brands: [],
          items: [],
          orders: []
        },
        portfolio: {
          enabled: false,
          dark: false,
          type: 'grid-1-column-detailed',
          categories: [],
          items: []
        },
        news: {
          enabled: false,
          items: []
        },
        units: {
          enabled: false
        },
        land: {
          enabled: false
        },
        properties: {
          enabled: false,
          items: [],
          units: [],
          land: []
        },
        events: {
          enabled: false,
          items: []
        },
        documents: {
          enabled: false,
          items: []
        },
        photos: {
          enabled: false,
          items: []
        },
        videos: {
          enabled: false,
          items: []
        },
        audio: {
          enabled: false,
          items: []
        },
        testimonials: {
          enabled: false,
          items: []
        },
        partners: {
          enabled: false,
          type: 'auto-play',
          items: []
        },
        team: {
          enabled: false,
          listType: 'default',
          centerTitle: '',
          title: '',
          items: []
        },
        faqs: {
          enabled: false,
          items: []
        },
        users: {
          enabled: false,
          items: []
        },
        leads: {
          enabled: false
        },
        sidebar: {
          enabled: false,
          sections: {
            documents: {
              enabled: false
            },
            contact: {
              enabled: false,
              title: '',
              items: []
            },
            paypal: {
              enabled: false,
              title: '',
              items: []
            },
            schedule: {
              enabled: false,
              title: '',
              items: [],
            },
            links: {
              enabled: false,
              title: '',
              items: []
            },
            custom: {
              enabled: false,
              title: '',
              content: ''
            }
          }
        },
        css: '',
      }
    }
  }
}

export default dataStore



// WEBPACK FOOTER //
// ./src/dataStore.js